var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46337",
    "data-name": "Group 46337",
    transform: "translate(-1549 -48.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Notification_Icon",
    "data-name": "Notification Icon",
    d: "M33.625,53.125h7.75a3.875,3.875,0,1,1-7.75,0Zm-9.688-1.937a1.938,1.938,0,0,1,0-3.875h.969c1.356-1.356,2.906-3.294,2.906-5.812V35.688a9.687,9.687,0,0,1,19.374,0V41.5c0,2.518,1.551,4.456,2.906,5.812h.969a1.938,1.938,0,1,1,0,3.875Z",
    transform: "translate(1527 22)",
    fill: "#bcbccb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.92ebb366eebd5c5f56f4b3628b052dcf.svg";
export { ForwardRef as ReactComponent };